<template>
	<div :class="{'border border-red border-md': debugMode}">
		<template v-if="debugMode">
			<div class="ao-p3-regular">AoGreatDatePicker</div>
			<pre
				class="mb-2"
				style="padding: 0.5rem; background-color: #3c3b3b; color: rgb(39, 136, 18); font-size: 12px;"
			><code>{{ {
				modelValue,
				companyTz,
				// guessedTz,
				min,
				max,
			} }}</code></pre>
		</template>
		<div :class="{'pa-2': debugMode}">
			<MainOfDatePicker
				:modelValue="modelValueWithoutTimezone"
				:min="minValueWithoutTimezone"
				:max="maxValueWithoutTimezone"
				:enableTimePicker="enableTimePicker"
				:label="label"
				:placeholder="placeholder"
				:error="error"
				:errorMessages="errorMessages"
				:hideDetails="hideDetails"
				:debugMode="debugMode"
				@blur="$emit('blur')"
				@update:modelValue="onUpdateModelValue"
			/>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'

import useMoment from '@/composables/useMoment.js'

import MainOfDatePicker from './date-range-picker/MainOfDatePicker.vue'

const props = defineProps({

	modelValue: {
		type: String,
		default: () => (null),
	},

	min: {
		type: String,
	},

	label: {
		type: String,
	},

	placeholder: {
		type: String,
	},

	max: {
		type: String,
	},

	maxIsCurrentTime: {
		type: Boolean,
		default: false,
	},

	enableTimePicker: {
		type: Boolean,
		default: false,
	},

	error: {
		type: Boolean,
		default: false,
	},

	errorMessages: {
		type: [Array, String],
		default: () => ([]),
	},

	hideDetails: {
		type: [Boolean, String],
		default: false,
	},

	debugMode: {
		type: Boolean,
		default: false,
	},

})

const emit = defineEmits([
	'update:modelValue',
	'blur',
])

const {
	moment,
	companyTz,
	formatDate,
	formatDateTime,
	addTimezoneValue,
} = useMoment()

const modelValueWithoutTimezone = computed(() => {
	if (typeof props.modelValue === 'string') {
		return props.enableTimePicker ? formatDateTime(props.modelValue, undefined, true) : formatDate(props.modelValue)
	}
	return props.modelValue
})

const minValueWithoutTimezone = computed(() => {
	if (props.min) {
		return formatDateTime(props.min, undefined, true)
	}
	return props.min
})

const maxValueWithoutTimezone = computed(() => {
	if (props.maxIsCurrentTime) {
		return formatDateTime(moment().format(), undefined, true)
	} else if (props.max) {
		return formatDateTime(props.max, undefined, true)
	}
	return props.max
})

const onUpdateModelValue = (value) => {
	if (props.debugMode) {
		// eslint-disable-next-line no-console
		console.log('AoGreatDatePicker onUpdateModelValue', value)
	}
	emit('update:modelValue', props.enableTimePicker ? addTimezoneValue(value, companyTz.value) : value)
}

</script>
